import React from 'react';
import PropTypes from 'prop-types';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';

export function VinDataRow({ feature: { name, value }, keyword = null }) {
  if (!value) {
    return null;
  }

  const escapeRegex = str => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  return (
    <tr>
      <th scope="row" className="py-0_75 ps-0 pe-0_5">
        {keyword ? (
          <ContentFragment componentToUse="span">
            {name.replaceAll(
              new RegExp(`${escapeRegex(keyword)}`, 'gi'),
              str => `<span class="bg-blue-90 py-0_25">${str}</span>`
            )}
          </ContentFragment>
        ) : (
          name
        )}
      </th>
      <td className="py-0_75 ps-0_5 pe-0">{value}</td>
    </tr>
  );
}

VinDataRow.propTypes = {
  feature: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  keyword: PropTypes.string,
};
